import { createAction, props } from "@ngrx/store";
import { IUpgradeChallengeOptionConfiguration } from "../../shared/model/newChallengeoptionConfiguration.model";

export const setUpgradeChallenge = createAction(
  "[Challenges V2] Set Upgrade Challenge",
  props<{ selectedChallenge: IUpgradeChallengeOptionConfiguration }>(),
);
